module.exports = {
  "rangeOverflow": function rangeOverflow(args) {
    return "V\xE4rdet m\xE5ste vara ".concat(args.maxValue, " eller tidigare.");
  },
  "rangeReversed": "Startdatumet m\xE5ste vara f\xF6re slutdatumet.",
  "rangeUnderflow": function rangeUnderflow(args) {
    return "V\xE4rdet m\xE5ste vara ".concat(args.minValue, " eller senare.");
  },
  "unavailableDate": "Det valda datumet \xE4r inte tillg\xE4ngligt."
};